import { useContext } from "react";

import { css } from "@emotion/react";
import TableCell from "@mui/material/TableCell";
import MuiTableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import Checkbox from "components/DesignComponents/Checkbox";
import TableContext from "context/table/tableContext";
import { Column, getIds, tableColumnDropShadow } from "shared";

import HeadColumn from "./HeadColumn";

const TableHead = ({ scrollHorizontal }: any) => {
    const {
        isNotSelectable,
        selectableRows,
        idType,
        columns,
        inlineActions,
        fixedColumnWidth,
        selectMultipleRows
    } = useContext(TableContext);

    const selectAllRows = () => {
        const ids = getIds(selectableRows, idType);
        selectMultipleRows(ids);
    };

    return (
        <MuiTableHead>
            <TableRow
                css={css({
                    ...(fixedColumnWidth && {
                        "& > th": {
                            minWidth: fixedColumnWidth,
                            maxWidth: fixedColumnWidth,
                            overflowX: "hidden"
                        },

                        "& > th:last-of-type": {
                            width: "100%"
                        }
                    })
                })}
            >
                {/* Checkbox */}
                {!isNotSelectable && (
                    <TableCell
                        css={css({
                            position: "sticky",
                            left: "0",
                            zIndex: "3"
                        })}
                    >
                        <div
                            css={css({
                                height: "24px"
                            })}
                        >
                            <Checkbox
                                checked={false}
                                onChange={selectAllRows}
                                disabled={selectableRows.length === 0}
                            />
                        </div>
                    </TableCell>
                )}

                {/* Column names */}
                {columns.map((column: Column) => {
                    return (
                        column.isActive && (
                            <HeadColumn
                                key={column.name}
                                data={column}
                                scrollHorizontal={scrollHorizontal}
                            />
                        )
                    );
                })}

                {inlineActions.length > 0 && (
                    <TableCell
                        sx={[
                            {
                                position: "sticky",
                                right: "0",
                                width: "0 !important",
                                padding: "0 !important"
                            },
                            tableColumnDropShadow(scrollHorizontal)
                        ]}
                    />
                )}
            </TableRow>
        </MuiTableHead>
    );
};

export default TableHead;
